import "./global"
import React from "react"
import ReactDOM from "react-dom"
import {app} from "./app"
import {createReduxStore} from "./redux"
import "./index.css"
import registerServiceWorker from "./registerServiceWorker"

// Needed for offline loading/progressive webapp.
// https://github.com/facebookincubator/create-react-app/releases/tag/v1.0.0
registerServiceWorker()

const store = createReduxStore()
const App = app({store})

ReactDOM.render(<App />, document.getElementById("root"))



// WEBPACK FOOTER //
// ./src/index.js